// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var MapSetting$ReactHooksTemplate = require("./mapSetting.res.js");
var ChartSetting$ReactHooksTemplate = require("./chartSetting.res.js");
var ScoreCardSetting$ReactHooksTemplate = require("./scoreCardSetting.res.js");

function fromJson(visualizationType, json) {
  if (visualizationType === "score_card") {
    return {
            TAG: "ScoreCardSetting",
            _0: ScoreCardSetting$ReactHooksTemplate.fromJson(json)
          };
  } else if (visualizationType === "map") {
    return {
            TAG: "MapSetting",
            _0: MapSetting$ReactHooksTemplate.fromJson(json)
          };
  } else {
    return {
            TAG: "ChartSetting",
            _0: ChartSetting$ReactHooksTemplate.fromJson(json)
          };
  }
}

exports.fromJson = fromJson;
/* No side effect */
